import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	fetch: false,
	succes: false,
	authSession: null,
};

const setFetchTrue = (state) => {
	state.fetch = true;
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		drop: () => initialState,
		login: setFetchTrue,
		logout: setFetchTrue,
		register: setFetchTrue,
		recover: setFetchTrue,
		update: setFetchTrue,
		check: setFetchTrue,
		setPass: setFetchTrue,
		remove: setFetchTrue,
		response: (state, action) => {
			if (action.payload) {
				state.authSession = action.payload;
			}
			state.fetch = false;
		},
		succes: (state, action) => {
			state.succes = action.payload;
		},
	},
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
